@if (isActionCard()) {
    <div class="TotemWidget TotemWidgetText TotemWidgetText--ActionCard card">
        <div class="alert border-0 m-0 {{ color ? 'alert-' + color + ' text-' + color : 'bg-white text-dark' }}">
            @if (overtitle) {
                <div class="text-muted">{{ overtitle | locTranslate }}</div>
            }
            @if (logo) {
                <div class="TotemWidgetText-Logo {{ isImage(logo) ? 'TotemWidgetText-Logo--Image' : 'TotemWidgetText-Logo--Icon' }}">
                    @if (isImage(logo)) {
                        <img [src]="logo" alt=""/>
                    }
                    @else {
                        <i class="fa-solid {{ logo }}" aria-hidden="true"></i>
                    }
                </div>
            }
            @if (title) {
                <h4 class="mb-2">{{ title | locTranslate }}</h4>
            }
            @if (description) {
                <div class="text-muted">{{ description | locTranslate }}</div>
            }
            @if (actionList?.length) {
                <div class="row mt-3 justify-content-center" role="group" [attr.aria-label]="title ? (title | locTranslate) : null">
                    @for (action of actionList; track action; let i = $index) {
                        <div class="col-12 col-sm-6 pt-3">
                            <button type="button" class="btn btn-block btn-{{ action.color || 'primary' }}" (click)="goToLink(action.link)">
                                @if (action.icon) {
                                    <i class="fa-regular {{ action.icon }}" aria-hidden="true"></i>
                                }
                                <span>{{ action.text | locTranslate }}</span>
                                <span class="visually-hidden"> {{ 'totem-a11y.opens-new-window' | locTranslate }}</span>
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
    </div>
}
@else {
    <div class="TotemWidget TotemWidgetText {{fullScreen ? 'TotemWidgetText--FullScreen' : 'card TotemWidgetText--' + size.toUpperCase() }}
        {{!fullScreen && getAbstractColorClass() ? 'text-' + getAbstractColorClass() : ''}}
        {{!fullScreen && getBackgroundClass() ? 'bg-' + getBackgroundClass() : ''}}"
        [style.color]="!fullScreen ? getAbstractColorStyle() : null"
        [style.backgroundColor]="!fullScreen ? getBackgroundStyle() : null"
        [attr.role]="!fullScreen ? 'button' : null"
        [attr.tabindex]="!fullScreen ? 0 : null"
        [attr.aria-label]="!fullScreen ? ('totem-a11y.open-details' | locTranslate) : null"
        (click)="onWidgetClick()"
        (keydown)="!fullScreen && onCardKeydown($event)">
        @if (!fullScreen) {
            <div class="card-body">
                @if (abstract || subAbstract || logo) {
                    <div class="TotemWidgetText-Abstract {{logo ? 'TotemWidgetText-Abstract--HasLogo' : ''}} {{logo && logoInvert ? 'TotemWidgetText-Abstract--HasLogoInvert' : ''}} {{cover ? 'TotemWidgetText-Abstract--HasCover' : ''}}">
                        @if (logo) {
                            <div class="TotemWidgetText-Logo {{isImage(logo) ? 'TotemWidgetText-Logo--Image' : 'TotemWidgetText-Logo--Icon'}}">
                                @if (isImage(logo)) {
                                    <img [src]="logo" alt=""/>
                                }
                                @if (!isImage(logo)) {
                                    <i class="fa-solid {{logo}}
                                    {{getAbstractColorClass() ? 'text-' + getAbstractColorClass() : ''}}
                                    {{getBackgroundClass() ? 'bg-' + getBackgroundClass() : ''}}"
                                    [style.backgroundColor]="getAbstractColorStyle()"
                                    [style.color]="getBackgroundStyle()"
                                    aria-hidden="true"
                                    ></i>
                                }
                            </div>
                        }
                        <div class="TotemWidgetText-Abstract-Content">
                            <h5 class="{{subAbstract ? '' : 'm-0'}}">{{abstract | locTranslate}}</h5>
                            <div>{{subAbstract | locTranslate}}</div>
                        </div>
                    </div>
                }
                @if (cover) {
                    <div class="TotemWidgetText-Cover">
                        <img [src]="cover | safe:'resourceUrl'" alt="">
                    </div>
                }
            </div>
        }
        @if (fullScreen) {
            @if(selectedProductId) {
                @if (isLoadingProduct) {
                    <app-pg-loading></app-pg-loading>
                }
                @if (!isLoadingProduct) {
                    <app-ef-product appMode="iframekiosk" [productData]="selectedProductData" [supplierData]="selectedProductSupplierData" [hasClose]="true" (doClose)="selectedProductId = null" (showProduct)="onShowProduct($event)"></app-ef-product>
                }
            }
            @else {
                <div class="TotemWidgetText-Content" [innerHTML]="fullScreenText | locTranslate"></div>

                @if(showProducts && filteredData != null) {
                    <div class="TotemWidgetText-Products">
                        <app-ef-list [vertical]="true" [full]="true" [productsData]="filteredData" (showProduct)="onShowProduct($event)"></app-ef-list>
                    </div>
                }
            }
        }
    </div>
}
